// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ label:'菜单类型',spanRows:24,type:'MenuSelect',modelValue:'type',op:'menuTypeOptions'},
	{ label:'上级菜单',spanRows:24,type:'firstSelect',modelValue:'parentId',placeholder:'请先选择菜单类型',op:'selectOptions'},
	{ label:'菜单名称',spanRows:24,type:'input',modelValue:'menuName',placeholder:'请输入修改菜单名称'},
	{ label:'菜单图标',spanRows:24,type:'input',iconDialogVisible:true,modelValue:'icon',placeholder:'请输入修改菜单图标'},
	{ label:'菜单路径',spanRows:24,type:'input',modelValue:'path',placeholder:'请输入修改菜单路径'},
	{ label:'标识码',spanRows:24,type:'input',modelValue:'perms',placeholder:'菜单所属标识码'},
	{ label:'组件名称',spanRows:24,type:'input',modelValue:'component',placeholder:'请输入菜单所属组件'},
	{ label:'排序号',spanRows:24,type:'inputNumber',modelValue:'orderNum',placeholder:'请输入菜单序号'},
]

